import { SvgIconOwnProps, SxProps } from '@mui/material';

import { Membership_Type } from '@occc/graphql';
import {
  BadgeOutlinedIcon,
  FaceOutlinedIcon,
  AssignmentIndOutlined,
} from '@occc-app/design-system';

type MembershipTypeIconProps = {
  membershipType: Membership_Type;
  isSelected?: boolean;
  color?: SvgIconOwnProps['color'];
};

export const MembershipTypeIcon = ({
  membershipType,
  isSelected = false,
  color,
}: MembershipTypeIconProps) => {
  const iconStyle: SxProps = { fontSize: 18, marginRight: 0.5, opacity: isSelected ? 1 : 0.5 };

  if (membershipType === Membership_Type.Employee) {
    return <BadgeOutlinedIcon sx={iconStyle} color={color} />;
  }

  if (membershipType === Membership_Type.Manager) {
    return <AssignmentIndOutlined sx={iconStyle} color={color} />;
  }

  return <FaceOutlinedIcon sx={iconStyle} color={color} />;
};
